<template>
  <div v-if="responseMsg" class="text-center redirect-div">
    {{ responseMsg }}
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import vuecookie from 'vue-cookies'
import { backendUrl } from '@/helpers/backendUrl.js'

export default {
  name: 'externalLogin',
  data() {
    return {
      sendingRequest: false,
      responseMsg: null
    }
  },
  created() {
    if(!this.sendingRequest) {
      this.sendingRequest = true
      let token = this.$route.params.token

      this.$store.commit('logIn', token)

      this.$store.dispatch('loginFromV1', {
        hash_token: token,
        business_unit: this.$route.params.business_unit ? this.$route.params.business_unit : null
      }).then(response => {
        if(response && response.status && response.status == 'error') {
          if(response.message) {
            this.responseMsg = response.message
          }
        }
      }, this)
    }
  },
  methods: {

  }
}
</script>

<style scoped>
  .redirect-div {
    height: 100vh;
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>